import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ShellComponent } from './shell.component';
import { NavbarComponent } from './navbar/navbar.component';
import { MessagesComponent } from './messages/messages.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { NotificacionesUsuarioComponent } from './notificaciones-usuario/notificaciones-usuario.component';
import { NotificacionDetalleComponent } from './notificacion-detalle/notificacion-detalle.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { AboutComponent } from './about/about.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbModule,
    InfiniteScrollDirective
  ],
  declarations: [
    ShellComponent,
    NavbarComponent,
    MessagesComponent,
    NotificacionesUsuarioComponent,
    NotificacionDetalleComponent, 
    AboutComponent,
  ]
})
export class ShellModule { }
